import { render } from "./CrudArtEngenheiroTransportador.vue?vue&type=template&id=002ca02a&scoped=true"
import script from "./CrudArtEngenheiroTransportador.vue?vue&type=script&lang=ts"
export * from "./CrudArtEngenheiroTransportador.vue?vue&type=script&lang=ts"

import "./CrudArtEngenheiroTransportador.vue?vue&type=style&index=0&id=002ca02a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-002ca02a"

export default script